import { Injectable } from '@angular/core';
import { COptions } from '../../../models/interfaces';
import { ApiWebService } from '../../../api/api/ApiWebService';
import { ProfileService } from '../../../core/profile/profile.service';
import { ExportToCsv } from 'export-to-csv';
import { MatDialog } from '@angular/material/dialog';
import { DialogCsvComponent } from '../../../shared/dialog/dialog-csv/dialog-csv.component';
import { CSVGroupLabel, CSVType } from '../../../models/csv-types';
import { LoadingService } from '../../../shared/loading/loading.service';
import { TableSettings, dataTable } from '../../../models/column-types';

@Injectable({
  providedIn: 'root',
})
export class TableCsvService {
  gridSettings!: TableSettings;
  dataExportCsv: unknown[] = [];
  headers: string[];
  order: string = null;
  columns: any[];
  keyColumns: string[];
  serviceConfig: ApiWebService;
  filter: string;
  id: string = '';
  labelsCsv: CSVGroupLabel;
  color: string;
  textColor: string;
  endPoint: string = '';

  export_csv: COptions = {
    filename: this.gridSettings && this.gridSettings.exportCsvName ? this.gridSettings.exportCsvName : 'export',
    exportHead: false,
    fieldSeparator: ';',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: false,
    showLabelsHix: false,
    showTitle: false,
    title: this.gridSettings && this.gridSettings.exportCsvName ? this.gridSettings.exportCsvName : 'export',
    useBom: true,
    headers: [''],
  };

  constructor(
    private _apiService: ApiWebService,
    private _profile: ProfileService,
    private _dialog: MatDialog,
    private _loading: LoadingService
  ) {}

  async getDataToCSV(endpoint: string, $Top?: number, $Orderby?: string): Promise<boolean> {
    $Orderby = this.filterAndOrder($Orderby);
    let finish: boolean = false;
    let aux: number = 0;
    let numReg: number = $Top ? $Top : null;
    let skip: number = 0;
    this.export_csv.headers = [];
    this.exportHeader();

    while (!finish) {
      skip = this.getNumReg(numReg, skip, aux);
      const result: dataTable = await this._apiService.GetWithHttpInfoAsync(
        this._profile.getToken(),
        endpoint,
        numReg,
        skip,
        this.filter,
        null,
        'allpages',
        $Orderby,
        null
      );

      if (result.Items.length) {
        if (numReg == null) {
          numReg = result.Items.length;
        }

        result.Items.forEach((data) => this.processItem(data));

        if (result.Count <= this.dataExportCsv.length) {
          finish = true;
        }
      }
      aux = aux + 1;
    }

    this._loading.set(false);

    return true;
  }

  private processItem(row: any) {
    let item: any = {};

    if (this.columns?.length) {
      this.columns.forEach((col) => {
        const element = col.key;
        item[element] = row[element] ?? '';
      });
    } else {
      for (const key in this.columns) {
        item[key] = row[key];
      }
    }

    this.dataExportCsv.push(item);

    if (Array.isArray(row.children) && row.children.length) {
      row.children.forEach((child) => this.processItem(child));
    }
  }

  exportDataCSVyes(saveConfig: number, dataCSV?: CSVType): void {
    if (saveConfig == 1) {
      this.export_csv.showLabelsHix = this.export_csv.showLabels = this.export_csv.exportHead;
      localStorage.setItem('export_csv[' + this.id + ']', JSON.stringify(this.export_csv));
    }

    this._loading.set(true);

    this.getDataToCSV(this.endPoint).then(() => {
      if (dataCSV) {
        this.export_csv.filename = dataCSV.csv.filename;
      }
      const data = this.dataExportCsv;
      data.forEach((obj: { options: undefined }) => delete obj.options);
      const csvExporter = new ExportToCsv(this.export_csv);
      csvExporter.generateCsv(data);
      if (this._dialog) {
        this._dialog.closeAll();
      }
    });
  }

  exportDataCSV(): void {
    this._dialog.open(DialogCsvComponent, {
      data: {
        csv: this.export_csv,
        submit: (data: CSVType) => {
          this.exportDataCSVyes(1, data);
        },
        exportHead: this.export_csv.exportHead,
        labelsCsv: this.labelsCsv,
        color: this.color,
        textColor: this.textColor,
      },
    });
    this.export_csv.showLabelsHix = this.export_csv.showLabels = this.export_csv.exportHead;
    localStorage.setItem('export_csv[' + this.id + ']', JSON.stringify(this.export_csv));
  }

  filterAndOrder(orderby: string): string {
    if (!this.filter) {
      this.filter = '';
    }

    this.dataExportCsv = [];

    if (orderby == undefined || orderby == '') {
      orderby = this.order;
    }
    return orderby;
  }

  exportHeader(): void {
    if (this.export_csv.exportHead) {
      for (const key in this.columns) {
        if (!this.columns[key].hidden && !this.columns[key].hiddencsv) {
          this.export_csv.headers.push(this.columns[key].key);
        }
      }
    }
  }

  getNumReg(numReg: number, skip: number, aux: number): number {
    if (numReg != null) {
      skip = numReg * aux;
    }
    return skip;
  }
}
